// src/reducers/userReducer.js
const initialState = {
    users: [],
    loading: false,
    error: null
  };
  
  export default function(state = initialState, action) {
    switch(action.type) {
      case 'GET_USERS_REQUEST':
      case 'ADD_USER_REQUEST':
        return {
          ...state,
          loading: true,
          error: null
        };
      case 'GET_USERS_SUCCESS':
        return {
          ...state,
          loading: false,
          users: action.payload,
          error: null
        };
      case 'ADD_USER_SUCCESS':
        return {
          ...state,
          loading: false,
          users: [...state.users, action.payload],
          error: null
        };
      case 'GET_USERS_FAIL':
      case 'ADD_USER_FAIL':
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  }